import { apiCallMultipart } from "./servicesCall";

export const POST_SERVICES = {
  create(data) {
    return apiCallMultipart("/post/create", data);
  },
  update(data) {
    return apiCallMultipart("/post/update", data);
  },
  detail(data) {
    return apiCallMultipart("/post/detail", data);
  },
  edit(data) {
    return apiCallMultipart("/post/edit", data);
  },
  categoryList(data) {
    return apiCallMultipart("/post/category/list", data);
  },
};
